import { Controller } from 'stimulus'

// Markup: a wrapper with data-controller="crm-filter", a trigger with data-action=
// "crm-filter#open", and the overlay as data-crm-filter-target="modal".
export default class extends Controller {
  static targets = ['modal', 'panel']

  connect() {
    this._onKey = (e) => { if (e.key === 'Escape') this.close() }
  }

  disconnect() {
    document.removeEventListener('keydown', this._onKey)
    document.body.style.overflow = ''
  }

  open(e) {
    if (e) e.preventDefault()
    this.modalTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
    document.addEventListener('keydown', this._onKey)
    const first = this.modalTarget.querySelector('input, select')
    if (first) setTimeout(() => first.focus(), 30)
  }

  close(e) {
    if (e) e.preventDefault()
    this.modalTarget.classList.add('hidden')
    document.body.style.overflow = ''
    document.removeEventListener('keydown', this._onKey)
  }

  // Close only when the click lands on the backdrop, not inside the panel.
  backdrop(e) {
    if (!this.panelTarget.contains(e.target)) this.close()
  }
}
